import { FC, memo, ReactNode } from 'react';
import classNames from 'classnames';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import TEXTS from '../texts';

import styles from './SelectableListHeader.module.scss';

interface SelectableListHeaderProps {
  className?: string;
  isLoading: boolean;
  headerLeftSlot?: ReactNode;
  onChangeAll: (value: boolean) => void;
  hasSelectedItems: boolean;
  hasUnselectedItems: boolean;
  totalItemsCount?: number;
  showItemsCount?: boolean;
}

const SelectableListHeader: FC<SelectableListHeaderProps> = ({
  className,
  headerLeftSlot,
  hasSelectedItems,
  hasUnselectedItems,
  totalItemsCount = 0,
  showItemsCount = false,
  isLoading,
  onChangeAll,
}) => {
  if (isLoading) {
    return (
      <div className={styles.skeleton}>
        <div className={styles.skeletonItem} />
        <div className={styles.skeleton}>
          <div className={styles.skeletonItem} />
          <div className={styles.skeletonItem} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        styles.headerMultiSelect,
        {
          [styles.headerMultiSelectWithoutItemsCount]: !showItemsCount,
        },
        className
      )}>
      <div className={styles.leftSlot}>
        <div>{headerLeftSlot}</div>
        {showItemsCount && <div>{TEXTS.SELECTABLE_LIST_FOUND(totalItemsCount)}</div>}
      </div>

      <div className={styles.multiSelectContainer}>
        {hasUnselectedItems && (
          <Button
            elementId="selectable_list_select_all"
            type={ButtonType.PLAIN}
            className={styles.button}
            onClick={() => onChangeAll(true)}
            isDisabled={isLoading}>
            {TEXTS.SELECTABLE_LIST_ALL}
          </Button>
        )}

        {hasSelectedItems && hasUnselectedItems && <span className={styles.dot}>•</span>}

        {hasSelectedItems && (
          <Button
            elementId="selectable_list_select_all_none"
            type={ButtonType.PLAIN}
            className={styles.button}
            onClick={() => onChangeAll(false)}
            isDisabled={isLoading}>
            {TEXTS.SELECTABLE_LIST_ALL_NONE}
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(SelectableListHeader);
